import { ImageProps } from '../Image/image.types';
import { MLBTheme } from '../../style/theme.types';

export enum TeamLogoTypes {
  CAP = 'cap',
  PRIMARY = 'primary',
  WORDMARK = 'wordmark',
  TEAM = 'team',
  SPOT = 'spot',
}

export interface TeamLogoProps extends Partial<ImageProps> {
  teamId?: string | number;
  teamLogoType?: TeamLogoTypes;
  darkMode?: boolean;
  theme?: MLBTheme;
  skeletonRounded?: boolean;
}

export interface SpotLogoProps extends Partial<ImageProps> {
  '1x': string;
  '2x': string;
  '3x': string;
}
